module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/50.7df479bc.png";